<script lang="ts">
    import Link from "svelte-link";
    import { Button, Col} from "sveltestrap";
    import {  DropdownSplitButton, href, PrimaryButton} from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Dropdown/Dropmenu.json"
</script>
<Col sm="12" xl="12">
    <Card headerTitle={DropdownSplitButton} CardBodyprops="dropdown-basic" cardHeaderprops="pb-0">
      <div slot="contentbody">
        <div class="btn-group">
          <Button color="primary">{PrimaryButton}</Button>
          <div class="dropdown separated-btn">
            <Button color="primary">
                <i class="icofont icofont-arrow-down"></i>
            </Button>
            <div class="dropdown-content">
                <Link href={href}>Link 1</Link>
                <Link href={href}>Link 2</Link>
                <Link href={href}>Link 3</Link>
            </div>
          </div>
        </div>
        {#each data.DropdownSplitButton as dropdownItem}
            <div class="btn-group">
                <Button color={dropdownItem.color}>{dropdownItem.name}</Button>
                <div class="dropdown separated-btn">
                <Button color={dropdownItem.color}>
                    <i class="icofont icofont-arrow-down"></i>
                </Button>
                <div class="dropdown-content">
                    <Link href={href}>Link 1</Link>
                    <Link href={href}>Link 2</Link>
                    <Link href={href}>Link 3</Link>
                </div>
                </div>
            </div>
        {/each}
      </div>
    </Card>
</Col>